import { formatDecimalValue as formatDecimalValueBase } from 'libs/form/fields/DecimalField/helpers';

import { MAX_FLOATING_POINTS } from '../constants';

export const formatDecimalValue = (price: string) =>
  formatDecimalValueBase(price, MAX_FLOATING_POINTS, 0);
